import React, { Component } from 'react'
import { bindActionCreators} from 'redux'
import { connect } from 'react-redux'
import _ from 'lodash'
import PropTypes from 'prop-types'
import {Link} from 'react-router-dom'
import { Breadcrumb, Segment, Label, Icon,  Button, Modal, Table, Dimmer, Loader, Image, Message } from 'semantic-ui-react'
import InventoryOnOrderSegment from '../utils/others/InventoryOnOrderSegment';
import {
    loadInventoryById, setNewAdjustmentModel, updateInventoryModelInStore,
    resetInventoryModelInStore
} from '../../actions/inventory'
import Dls from '../../lib'
import InventoryAdjustmentForm from '../forms/inventories/Adjustment'
import InventoryHistoryComponent from "./InventoryHistoryComponent"
import { api } from '../../api';

const PARAGRAPH_HOLDER = require("../../assets/paragraph.png");

class InventoryViewPage extends Component {
    constructor() {
        super();
        this.state = {
            syncLoad: false,
            showAdjustmentModal: false
        }
    }
    componentDidMount() {
        const {jwt} = this.props;
        const {id} = this.props.match.params;
        this.props.loadInventoryById(jwt, id).catch(err => {
            Dls.apiErrorAlert(err);
        });;
    }

    onInventoryAdjusted = () => {
        this.onAdjustmentModalClose();
        const {jwt} = this.props;
        const {id} = this.props.match.params;
        this.props.loadInventoryById(jwt, id).catch(err => {
            Dls.apiErrorAlert(err);
        });;
    }

    onAdjustmentModalClose = () => {
        this.setState({
            showAdjustmentModal: false
        })
    }

    onAdjustmentOpen = () => {
        this.props.setNewAdjustmentModel(this.props.model.id);
        this.setState({showAdjustmentModal: true});
    }

    onQbSyncClick = () => {
        console.log("on qb sync");
    }
    
    
    onHostSyncClick = () => {
        this.setState({
            syncLoad: true
        })
        api.inventory.syncWithHost(this.props.jwt, this.props.model.id).then(res => {
            this.setState({
                syncLoad: false
            })
            const {data} = res.data;
            this.props.updateInventoryModelInStore('y3pl_id', data.y3pl_id);
        }).catch(err => {
            Dls.apiErrorAlert(err);
        });
    }

    getReserved = (warehouseId) => {
        const {qty_warehouse_reserved} = this.props.model;
        let reserved = 0;
        if (_.isArray(qty_warehouse_reserved)) {
            _.each(qty_warehouse_reserved, reservedRecord => {
                if (_.toInteger(warehouseId) === _.toInteger(reservedRecord.warehouse_id)) {
                    reserved = Math.abs(_.toInteger(reservedRecord.reserve));
                }
            });
        }

        return reserved;
    }

    getInstock = (warehouseId) => {
        const {qty_warehouse_instock} = this.props.model;
        let instock = 0;
        if (_.isArray(qty_warehouse_instock)) {
            _.each(qty_warehouse_instock, instockRecord => {
                if (_.toInteger(warehouseId) === _.toInteger(instockRecord.warehouse_id)) {
                    instock = _.toInteger(instockRecord.instock);
                }
            });
        }

        return instock;
    }

    getWarehouseName = (warehouseId) => {
        const {warehouses} = this.props;
        
        let warehouse = warehouses.filter(i => {
            return parseInt(i.value) === parseInt(warehouseId)
        })

        if (!_.isEmpty(warehouse) && warehouse.length === 1) {
            return warehouse[0].text
        } else {
            return "NA"
        }
    }

    componentWillUnmount() {
        //console.log("Model reset");
        this.props.resetInventoryModelInStore();
    }

    render() {
        const {model, warehouses} = this.props;
        return (
            <div>
                {_.isEmpty(model) ? <div className="row">
                    <div className="col-md-12">
                        <Segment>
                            <Dimmer active inverted>
                                <Loader content='Loading' />
                            </Dimmer>
                            <Image src={PARAGRAPH_HOLDER} />
                        </Segment>
                    </div>
                </div> : 
                    <div>
                        <div className="row">
                            <div className="col-md-8">
                                <Breadcrumb size="huge">
                                    <Breadcrumb.Section>
                                        <Link
                                            to={`/inventories/${Dls.pagination.inventories()}`}
                                        >
                                            Inventories
                                        </Link>
                                    </Breadcrumb.Section>
                                    <Breadcrumb.Divider />
                                    <Breadcrumb.Section>
                                        {model.id ? model.sku : `Create New Inventory`}
                                    </Breadcrumb.Section>
                                </Breadcrumb>
                            </div>
                            <div className="col-md-4">
                                <div style={{ float: "right" }}>
                                    {model.type === 'Inventory' ? <Button size="mini" color="violet" icon onClick={() => {this.onAdjustmentOpen()}}>
                                        <Icon name="wrench" />&nbsp;
                                        Adjust
                                    </Button> : null}
                                    <Button size="mini" 
                                        color="teal" 
                                        icon as={Link} 
                                        to={`/inventories/${model.id}/edit`}>
                                        <Icon name="barcode" />&nbsp;
                                        Edit
                                    </Button>
                                    <Button size="mini" color="teal" icon as={Link} to='/inventories/new/edit'>
                                        <Icon name="barcode" />&nbsp;
                                        Create New
                                    </Button>
                                </div>
                            </div>
                        </div>
                        <div className="row" style={{marginTop: '5px'}}>
                            <div className="col-md-12">
                                <Segment raised>
                                    <Label color='teal' ribbon>
                                        Inventory
                                    </Label>
                                    <div className="row">
                                        <div className="col-md-3">
                                            <div style={{marginTop: '3px'}}>
                                                SKU: <br />
                                                <strong>{model.sku ? model.sku : <br />}</strong>
                                            </div>
                                            
                                            <div style={{marginTop: '3px'}}>
                                                Inventory Status: <br />
                                                <strong>{model.status ? model.status : <br />}</strong>
                                            </div>
                                            <div style={{marginTop: '3px'}}>
                                                Inventory Type: <br />
                                                <strong>{model.type ? model.type : <br />}</strong>
                                            </div>
                                            <div style={{marginTop: '3px'}}>
                                                Integration: <br />
                                                {model.acct_id ? 
                                                    <Label size='mini' as={Button} onClick={() => this.onQbSyncClick()} color='green'>QB</Label> : 
                                                    <Label size='mini' as={Button} onClick={() => this.onQbSyncClick()} color='red'>QB</Label>}
                                                {model.woo_id ? 
                                                    <Label size='mini' as={Button} onClick={() => this.onWooSyncClick()} color='green'>Woo</Label> : 
                                                    <Label size='mini' as={Button} onClick={() => this.onWooSyncClick()} color='red'>Woo</Label>}
                                                {model.y3pl_id && !this.state.syncLoad ? <Label size='mini' color='green' as={Button}
                                                    onClick={() => this.onHostSyncClick()}
                                                >Host</Label> : null}
                                                {!model.y3pl_id && !this.state.syncLoad ? <Label size='mini' color='red'  as={Button}
                                                    onClick={() => this.onHostSyncClick()}
                                                >Host</Label> : null}
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div style={{marginTop: '3px'}}>
                                                Inventory Name: <br /><strong>{model.name ? model.name : <br />}</strong>
                                            </div>
                                            <div style={{marginTop: '3px'}}>
                                                Inventory Description: <br />
                                                <strong>{model.description ? model.description : <br />}</strong>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div style={{marginTop: '3px'}}>
                                                UPC Code: <br />
                                                <strong>{model.upc ? model.upc : <br />}</strong>
                                            </div>
                                            <div style={{marginTop: '3px'}}>
                                                Cost Price: <br />
                                                <strong>$ {model.cost ? Math.round(model.cost * 100) / 100 : <br />}</strong>
                                            </div>
                                            <div style={{marginTop: '3px'}}>
                                                Selling Price: <br />
                                                <strong>$ {model.selling ? Math.round(model.selling * 100) / 100 : <br />}</strong>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div style={{marginTop: '3px'}}>
                                                Custom Field 1: <br />
                                                <strong>{model.custom_1 ? model.custom_1 : <br />}</strong>
                                            </div>
                                            <div style={{marginTop: '3px'}}>
                                                Custom Field 2: <br />
                                                <strong>{model.custom_2 ? model.custom_2 : <br />}</strong>
                                            </div>
                                            <div style={{marginTop: '3px'}}>
                                                Custom Field 3: <br />
                                                <strong>{model.custom_3 ? model.custom_3 : <br />}</strong>
                                            </div>
                                        </div>
                                    </div>
                                </Segment>
                            </div>
                        </div>

                        {model.type === 'Inventory' ? <div className="row" style={{marginTop: '5px'}}>
                            <div className="col-md-6">
                                <Segment raised>
                                    <Label color='teal' ribbon>
                                        Stock
                                    </Label>
                                    <div className="row" style={{marginTop: '5px'}}>
                                        <div className="col-md-12">
                                            <Table compact>
                                                <Table.Header>
                                                    <Table.Row>
                                                        <Table.HeaderCell>Warehouse</Table.HeaderCell>
                                                        <Table.HeaderCell>Reserved</Table.HeaderCell>
                                                        <Table.HeaderCell>In Stock</Table.HeaderCell>
                                                        <Table.HeaderCell>Available</Table.HeaderCell>
                                                    </Table.Row>
                                                </Table.Header>
                                                <Table.Body>
                                                    {warehouses.map(wh => {
                                                        const instock = this.getInstock(wh.value);
                                                        const reserved = this.getReserved(wh.value);
                                                        return <Table.Row key={wh.value}>
                                                            <Table.Cell>
                                                                {wh.text}
                                                            </Table.Cell>
                                                            <Table.Cell>
                                                                {reserved}
                                                            </Table.Cell>
                                                            <Table.Cell>
                                                                {instock}
                                                            </Table.Cell>
                                                            <Table.Cell>
                                                                {instock - reserved}
                                                            </Table.Cell>
                                                        </Table.Row>
                                                    })}
                                                </Table.Body>
                                            </Table>
                                        </div>
                                    </div>
                                </Segment>
                            </div>
                            <div className="col-md-6">
                                <Segment raised>
                                    <Label color='teal' ribbon>
                                        On Shipments
                                    </Label>
                                    <div className="row" style={{marginTop: '5px'}}>
                                        <div className="col-md-12">
                                            <Table compact>
                                                <Table.Header>
                                                    <Table.Row>
                                                        <Table.HeaderCell>Warehouse</Table.HeaderCell>
                                                        <Table.HeaderCell>Order #</Table.HeaderCell>
                                                        <Table.HeaderCell>Relation</Table.HeaderCell>
                                                        <Table.HeaderCell>Quantity</Table.HeaderCell>
                                                    </Table.Row>
                                                </Table.Header>
                                                <Table.Body>
                                                    {model.shipment_lines.map(line => {
                                                        const {shipment} = line;
                                                        const {order, relation_name} = shipment;
                                                        return (
                                                            <Table.Row key={line.id}>
                                                                <Table.Cell>{this.getWarehouseName(shipment.warehouse_id)}</Table.Cell>
                                                                <Table.Cell>
                                                                    {order ? <Link to={`/${_.kebabCase(order.type)}s/${order.id}/view`}>
                                                                        {order.so}
                                                                    </Link> : null}
                                                                </Table.Cell>
                                                                <Table.Cell>
                                                                    {relation_name ? relation_name.company_name : null}
                                                                </Table.Cell>
                                                                <Table.Cell>
                                                                    {line.quantity}
                                                                </Table.Cell>
                                                            </Table.Row>
                                                        )
                                                    })}
                                                </Table.Body>
                                            </Table>
                                        </div>
                                    </div>
                                </Segment>
                            </div>
                            <div className="col-md-6" style={{marginTop: '5px'}}>
                                <InventoryOnOrderSegment
                                    list={_.isArray(model.on_order) ? model.on_order : []}
                                />
                            </div>
                        </div> : null}

                        {model.type === 'Inventory' && model.id ? <InventoryHistoryComponent 
                            id={model.id}
                            jwt={this.props.jwt}
                        /> : null}

                        <div className="row" style={{marginTop: '5px'}}>
                            <div className="col-md-12">
                                <Segment raised>
                                    <Label color='teal' ribbon>
                                        Shopify
                                    </Label>
                                    {model.spr ? <Message info>
                                        You should only manage non-S.P Richards inventories here. For S.P Richards products, go to SPR Products menu, or click <Link to={`/settings/ecommerce/products/${model.spr.id}/edit`}>here</Link>
                                    </Message> : <div>
                                        <div className="row" style={{marginTop: '5px'}}>
                                            <div className="col-md-3">
                                                <div style={{marginTop: '3px'}}>
                                                    Sell On Shopify: <br />
                                                    <strong>{model.is_shopify_item ? <Label size='mini' color='green'>Yes</Label> : "No"}</strong>
                                                </div>
                                                <div style={{marginTop: '3px'}}>
                                                    Schedule To Update: <br />
                                                    <strong>{model.should_update_shopify ? <Label size='mini' color='green'>Yes</Label> : "No"}</strong>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div style={{marginTop: '3px'}}>
                                                    Shopify Id: <br />
                                                    <strong>{model.shopify_id ? model.shopify_id : <br />}</strong>
                                                </div>
                                                <div style={{marginTop: '3px'}}>
                                                    Shopify Variant Id: <br />
                                                    <strong>{model.shopify_variant_id ? model.shopify_variant_id : <br />}</strong>
                                                </div>
                                                <div style={{marginTop: '3px'}}>
                                                    Shopify Vendor: <br />
                                                    <strong>{model.shopify_vendor ? model.shopify_vendor : <br />}</strong>
                                                </div>
                                                <div style={{marginTop: '3px'}}>
                                                    Shopify Type: <br />
                                                    <strong>{model.shopify_type ? model.shopify_type : <br />}</strong>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                
                                                <div style={{marginTop: '3px'}}>
                                                    Shopify Tag 1 (Menu Tag): <br />
                                                    <strong>{model.category_1 ? model.category_1 : <br />}</strong>
                                                </div>
                                                <div style={{marginTop: '3px'}}>
                                                    Shopify Tag 2 (Second Level Tag): <br />
                                                    <strong>{model.category_2 ? model.category_2 : <br />}</strong>
                                                </div>
                                                <div style={{marginTop: '3px'}}>
                                                    Shopify Tag 3 (Third Level Tag): <br />
                                                    <strong>{model.category_3 ? model.category_3 : <br />}</strong>
                                                </div>
                                                <div style={{marginTop: '3px'}}>
                                                    Home Page Best Seller Tag: <br />
                                                    <strong>{model.category_4 ? model.category_4 : <br />}</strong>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row" style={{marginTop: '5px'}}>
                                            <div className="col-md-12">
                                                HTML Description: <br />
                                                {model.html_description}
                                            </div>
                                        </div>
                                    </div>}
                                </Segment>
                            </div>
                        </div>
                    
                        <Modal size='tiny' 
                            open={this.state.showAdjustmentModal}
                            closeOnDimmerClick={false}
                            onClose={this.onAdjustmentModalClose}>
                            <Modal.Header>Create Inventory Adjustment</Modal.Header>
                            <Modal.Content>
                                <InventoryAdjustmentForm 
                                    onModalClose = {() => this.onAdjustmentModalClose()}
                                    inventoryAdjusted = {() => this.onInventoryAdjusted()}
                                />
                            </Modal.Content>
                        </Modal>
                    </div>
                }
            </div>
        )
    }
}

InventoryViewPage.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func.isRequired
     }).isRequired,
    loadInventoryById: PropTypes.func.isRequired,
    warehouses: PropTypes.array.isRequired,
    setNewAdjustmentModel: PropTypes.func.isRequired,
    updateInventoryModelInStore: PropTypes.func.isRequired,
    resetInventoryModelInStore: PropTypes.func.isRequired
};

function mapStateToProps(state) {
    return {
        jwt: state.auth.jwt,
        model: state.inventory.model,
        warehouses: state.system.resources.warehouses
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        loadInventoryById, setNewAdjustmentModel, updateInventoryModelInStore,
        resetInventoryModelInStore
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(InventoryViewPage)


// WEBPACK FOOTER //
// ./src/components/inventories/InventoryView.js